export const TRANSLATION_LANGUAGES = [
  { code: "pt", label: "Português" },
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "it", label: "Italiano" },
  { code: "de", label: "Deutsch" },
];

export const getLanguageLabel = (code) => {
  const match = TRANSLATION_LANGUAGES.find(
    (item) => item.code === (code || "").toLowerCase()
  );
  return match?.label || (code || "").toUpperCase();
};
